import React from 'react';
import { Switch, Redirect, Route, withRouter } from 'react-router-dom';
import { UsergroupAddOutlined } from '@ant-design/icons';
import { prop } from 'ramda';
import MenuLayout from '../../components/MenuLayout';
import Users from './Users';

const menuItems = [
  {
    label: 'Utilisateurs',
    icon: <UsergroupAddOutlined className="mr-3" />,
    path: '/utilisateurs'
  }
];

const Routes = ({ match }) => {
  const matchUrl = prop('url', match);
  return (
    <MenuLayout title="FlexiDocs Admin" menuItems={menuItems}>
      <Switch>
        <Route exact path={matchUrl}>
          <Redirect to={`${matchUrl}/utilisateurs`} />
        </Route>
        <Route path={`${matchUrl}/utilisateurs`} component={Users} />
      </Switch>
    </MenuLayout>
  );
};

export default withRouter(Routes);